module.exports = __webpack_public_path__ + "static/media/LET.ec08f941.svg";